import { render } from "./SaveOAuthClient.vue?vue&type=template&id=1da226e8&scoped=true"
import script from "./SaveOAuthClient.vue?vue&type=script&lang=js"
export * from "./SaveOAuthClient.vue?vue&type=script&lang=js"

import "./oauth-client.scss?vue&type=style&index=0&id=1da226e8&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da226e8"]])

export default __exports__